import axiosInstance from './AxiosInstance';

/**
 * Get active messages by message type
 * @param {string} messageType - The type of message (e.g., 'maintenance', 'DEBIT', 'CREDIT')
 * @returns {Promise} - API response with active messages
 */
export const getActiveMessagesByType = (messageType) => {
  return axiosInstance.get(`application-messages/type/${messageType}`);
};

/**
 * Get all active messages
 * @returns {Promise} - API response with all active messages
 */
export const getAllActiveMessages = () => {
  return axiosInstance.get('application-messages/active');
};
